import { Component, OnInit, HostListener } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { asq, imageURI } from 'environments/properties';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'act-dialog-special-day',
  templateUrl: './dialog-special-day.component.html',
  styleUrls: ['./dialog-special-day.component.scss']
})
export class DialogSpecialDayComponent implements OnInit {

  private URI = `${asq}`;
  private ImageURI = `${imageURI}`;
  private isMobile = false;

  constructor(
    public dialogRef: MdDialogRef<DialogSpecialDayComponent>,
    private utilitiesService: UtilitiesService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilitiesService.isMobile();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = this.utilitiesService.isMobile();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-special-day/dialog-special-day.component.ts